import { render, staticRenderFns } from "./PressHold.vue?vue&type=template&id=3c3aa75e&scoped=true&"
import script from "./PressHold.vue?vue&type=script&lang=js&"
export * from "./PressHold.vue?vue&type=script&lang=js&"
import style0 from "./PressHold.vue?vue&type=style&index=0&id=3c3aa75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3aa75e",
  null
  
)

export default component.exports